module.exports = __webpack_public_path__ + "img/img7.89275896.jpg";